import { c as _c } from "react/compiler-runtime";
import VideoWalkthroughCard from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/VideoWalkthroughCard';
import { ContentSection } from '@src/components/sco/LayoutBlocks/ContentSection';
import React from 'react';
export const AutomatedOutreachContent = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VideoWalkthroughCard url="/assets/videos/investor-match/send-messages.mp4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ContentSection component={t0} componentPlacement="right" description="Sending individual, customized emails to every investor is a giant pain in the ass! So we'll just do that for you. Connect your existing email service (Gmail, Outlook, and SMTP/IMAP) and we'll send all of your outreach directly from you so investors can reply directly." title="Automatic Email Outreach" buttons={[{
      title: "Start Sending Pitches",
      href: "/investors/matching/start",
      variant: "cta"
    }]} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};